import { BillingMode } from '../../../../services/exports/Constants';

export default {
  billing_modes: {
    [BillingMode.Stripe]: 'Metodo di pagamento',
    [BillingMode.InternalInvoicing]: 'Pagamenti',
  },
};
